import {
  isModuleEnabled,
  type CompanyModules,
} from '@bill-alps/backend/features/companies/modules';

export interface CompanyCatalogSettings extends CompanyModules {
  catalogEnabled?: boolean;
}

/** The saved preference, independent of the parent invoicing module. */
export function isCatalogPreferenceEnabled(
  company: CompanyCatalogSettings | null | undefined,
): boolean {
  if (!company) return false;
  return company.catalogEnabled ?? true;
}

/** Catalogue access requires both invoicing and the saved catalogue switch. */
export function isCatalogEnabled(
  company: CompanyCatalogSettings | null | undefined,
): boolean {
  return (
    isModuleEnabled(company, 'invoicing') && isCatalogPreferenceEnabled(company)
  );
}

export function assertCatalogEnabled(
  company: CompanyCatalogSettings | null | undefined,
): void {
  if (!isCatalogEnabled(company)) {
    throw new Error('PRODUCT_CATALOG_DISABLED');
  }
}
